import React, { useState } from 'react';
import { Select, MenuItem, FormControl, Box, SelectChangeEvent } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useCountry } from '../../context/CountryContext';
import { COUNTRY_OPTIONS, CountryCode } from '../../utils/countries';
import gbFlag from '../../assets/gb.png';
import frFlag from '../../assets/fr.png';
import ieFlag from '../../assets/ie.png';
import sophareLogo from '../../assets/sophare-logo.svg';
import './Header.css';

interface HeaderProps {
    selectedTab: number;
    onTabChange: (index: number) => void;
}

const navItems = [
    { label: 'Market Overview', index: 0, path: '/market' },
    { label: 'Search Company', index: 1, path: '/company' },
    { label: 'By Industry', index: 2, path: '/industry' },
    { label: 'Methodology', index: 3, path: '/methodology' },
];

const Header: React.FC<HeaderProps> = ({ selectedTab, onTabChange }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const { country, setCountry } = useCountry();
    const navigate = useNavigate();

    const handleChange = (event: SelectChangeEvent<string>) => {
        setCountry(event.target.value as CountryCode);
    };

    const countryFlags: Record<CountryCode, string> = {
        gb: gbFlag,
        fr: frFlag,
        ie: ieFlag,
    };

    const handleTabChange = (index: number) => {
        onTabChange(index);
        const target = navItems.find((item) => item.index === index);
        if (target) navigate(target.path);
        setIsMobileMenuOpen(false);
    };
    return (
        <Box component="nav" className="top-nav" id="TopNav">
            <Box className="top-nav-content">
                <Box className="menu-left">
                    <button
                        type="button"
                        className="mobile-menu-toggle"
                        aria-label="Toggle menu"
                        aria-expanded={isMobileMenuOpen}
                        onClick={() => setIsMobileMenuOpen((prev) => !prev)}
                    >
                        <span />
                        <span />
                        <span />
                    </button>
                    <Link to="/market" className="header-title hoverable-black">
                        <img src={sophareLogo} alt="Sophare logo" className="header-logo" />
                        Sophare Global Pay Gap Monitor
                    </Link>
                    <Box className="menu-links" role="tablist" aria-label="Dashboard sections">
                        {navItems.map((item) => (
                            <button
                                key={item.label}
                                type="button"
                                role="tab"
                                aria-selected={selectedTab === item.index}
                                aria-controls={`simple-tabpanel-${item.index}`}
                                id={`simple-tab-${item.index}`}
                                className={`menu-link ${selectedTab === item.index ? 'menu-link-active' : ''}`}
                                onClick={() => handleTabChange(item.index)}
                            >
                                {item.label}
                            </button>
                        ))}
                    </Box>
                </Box>
                <Box className="menu-controls">
                    <FormControl size="small" variant="outlined" className="country-select">
                        <Select
                            value={country}
                            onChange={handleChange}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Country selection' }}
                        >
                            {COUNTRY_OPTIONS.map((option) => (
                                <MenuItem value={option.code} key={option.code}>
                                    <img src={countryFlags[option.code]} alt={`${option.label} Flag`} className="country-flag" />
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </Box>
            {isMobileMenuOpen && (
                <Box className="mobile-menu" role="tablist" aria-label="Dashboard sections">
                    {navItems.map((item) => (
                        <button
                            key={item.label}
                            type="button"
                            role="tab"
                            aria-selected={selectedTab === item.index}
                            aria-controls={`simple-tabpanel-${item.index}`}
                            id={`mobile-simple-tab-${item.index}`}
                            className={`mobile-menu-link ${selectedTab === item.index ? 'mobile-menu-link-active' : ''}`}
                            onClick={() => handleTabChange(item.index)}
                        >
                            {item.label}
                        </button>
                    ))}
                </Box>
            )}
        </Box>
    );
};

export default Header;
